import React from 'react';
import { getContext } from 'common';
import List from 'components/List';

const ELEVATION_INDEX = 0; // MultiSelect component gets the elevation
const ELEVATION_TRANSPARENT = true;

export interface MultiSelectSmartCheckboxListProps extends React.ComponentPropsWithRef<'div'> {
  /** To render the list items, consider using 'MultiSelectSmartListCheckbox', 'MultiSelectSmartListDivider'. */
  children: React.ReactNode;
  /** @ignore */
  style?: React.CSSProperties
}

/** Component that acts as a container for displaying a vertical list of checkboxes.
 *  Any other props than 'MultiSelectSmartCheckboxList' props will be provided to the root element.
*/
const MultiSelectSmartCheckboxList = React.forwardRef<HTMLElement, MultiSelectSmartCheckboxListProps>((props: MultiSelectSmartCheckboxListProps, ref) => getContext(({ theme }) => {
  const {
    children,
    style,
    ...otherProps
  } = props;

  return (
    <List
      ref={ref}
      style={{ borderBottom: `0.0625rem solid ${(theme.LIST.VERTICAL.divider) as string}`, ...style }}
      elevationProps={{
        elevationIndex: ELEVATION_INDEX,
        transparent: ELEVATION_TRANSPARENT,
      }}
      {...otherProps}
    >
      {children}
    </List>
  );
}));

MultiSelectSmartCheckboxList.defaultProps = {
  style: {}
};
MultiSelectSmartCheckboxList.displayName = 'MultiSelectSmartCheckboxList';

export default MultiSelectSmartCheckboxList;
